<template #default>
  <div class="container-fluid p-0 m-0">
    <div class="row m-0 p-0  justifyCenter">
      <div class="col-10 m-0 p-0 text-Rot">
        <h4>2005</h4>
      </div>
    </div>

    <div class="row m-0 p-0  justifyCenter">
      <div class="col-6 col-md-3 m-0 p-0 text-center">
        <p v-if="sprachID === 0">Ausgabe 1</p>
        <p v-if="sprachID === 1">output 1</p>
        
        <ul class="noDeko">
          <li
            class="borderRund"
            @click="openPDF('IHV/IHVHeft12005.pdf')"
          >
            <span v-if="sprachID === 0" class="bold">Inhaltsverzeichnis</span>
            <span v-if="sprachID === 1" class="bold">Table of Contents</span>
          </li>
          
        </ul>
      </div>
      <div class="col-6 col-md-3 m-0 p-0 text-center">
        <p v-if="sprachID === 0">Ausgabe 2</p>
        <p v-if="sprachID === 1">output 2</p>
        
        <ul class="noDeko">
          <li
            class="borderRund"
            @click="openPDF('IHV/IHVHeft22005.pdf')"
          >
            <span v-if="sprachID === 0" class="bold">Inhaltsverzeichnis</span>
            <span v-if="sprachID === 1" class="bold">Table of Contents</span>
          </li>
          
        </ul>
      </div>
      <div class="col-6 col-md-3 m-0 p-0 text-center">
        <p v-if="sprachID === 0">Ausgabe 3</p>
        <p v-if="sprachID === 1">output 3</p>
        
        <ul class="noDeko">
          <li
            class="borderRund"
            @click="openPDF('IHV/IHVHeft32005.pdf')"
          >
            <span v-if="sprachID === 0" class="bold">Inhaltsverzeichnis</span>
            <span v-if="sprachID === 1" class="bold">Table of Contents</span>
          </li>
          
        </ul>
      </div>
      <div class="col-6 col-md-3 m-0 p-0 text-center">
        <p v-if="sprachID === 0">Ausgabe 4</p>
        <p v-if="sprachID === 1">output 4</p>
        
        <ul class="noDeko">
          <li
            class="borderRund"
            @click="openPDF('IHV/IHVHeft42005.pdf')"
          >
            <span v-if="sprachID === 0" class="bold">Inhaltsverzeichnis</span>
            <span v-if="sprachID === 1" class="bold">Table of Contents</span>
          </li>
          
        </ul>
      </div>
    </div>
    <div class="row m-0 p-0 justifyCenter">
      <div class="col-12 col-md-4 m-0 p-0 text-center">
        <ul class="noDeko">
          <li class="borderRund" @click="openPDF('IHV/IHV2005.pdf')">
                        <span v-if="sprachID === 0" class="bold">Jahresinhaltsverzeichnis</span>            
            <span v-if="sprachID === 1" class="bold">Annual table of contents</span>
          </li>          
        </ul>
      </div>
     
    </div>
  </div>
</template>
<script>

import { openModal } from "jenesius-vue-modal";
import modalPDF from "../../components/ModalPDF.vue";

export default {
  name: "J2005",
  methods: {
    openPDF(pdf) {
      const props = { pdf: pdf };
      openModal(modalPDF, props);
    },
  },
    computed: {
    sprachID() {
      let sprachID = this.$store.getters.getSprachID;
      return sprachID;
    },
  },
}



</script>